import { connect } from "react-redux";
import { formValueSelector } from "redux-form";
import { bindActionCreators } from "redux";
import Form from "../../components/forms/InitiativeFormAdding";
import { newInitiative, withRedirect } from "../../CroActions";
import { breadcrumbs } from "../../../../actions/appActions";
import { noop } from "lodash";

const selector = formValueSelector("initiativeForm");

const mapStateToProps = (state, { params }) => ({
  breadcrumbsItems: [{ label: "Nový podnět" }],
  legalPerson: selector(state, "legalPerson"),
  attachments: selector(state, "attachments") || [],
  isNew: true,
  rejectText: selector(state, "rejectText"),
  text: selector(state, "text"),
});

const onSubmit = withRedirect(newInitiative, "/verejnost");

const mapDispatchToProps = (dispatch, props) => ({
  ...bindActionCreators({ onSubmit, breadcrumbs }, dispatch),
  accept: noop,
  reject: noop,
  send: noop,
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Form);
